var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCornerArrowUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Size=16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.71713 3.05051C9.87334 2.8943 10.1266 2.8943 10.2828 3.05051L12.9495 5.71717C13.1057 5.87338 13.1057 6.12665 12.9495 6.28286C12.7933 6.43907 12.54 6.43907 12.3838 6.28286L10.4 4.29904V10C10.4 10.6365 10.1471 11.247 9.69703 11.6971C9.24695 12.1472 8.6365 12.4 7.99998 12.4H3.99998C3.77906 12.4 3.59998 12.2209 3.59998 12C3.59998 11.7791 3.77906 11.6 3.99998 11.6H7.99998C8.42432 11.6 8.83129 11.4314 9.13135 11.1314C9.43141 10.8313 9.59998 10.4244 9.59998 10V4.29904L7.61615 6.28286C7.45994 6.43907 7.20668 6.43907 7.05047 6.28286C6.89426 6.12665 6.89426 5.87338 7.05047 5.71717L9.71713 3.05051Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCornerArrowUp);
export default __webpack_public_path__ + "static/media/corner_arrow_up.0aab265078065edda689c3a9d14a2d62.svg";
export { ForwardRef as ReactComponent };